// <html lang="xxx"> を解決する
// en => en
// zh-cn => zh-Hans (simplifiedのs)
// zh-tw => zh-Hant（traditionalのt）
// ko => ko
// 中国語のlanguageは複数書き方があるが、今回は対象地域ではなく言語なので、上記が適当と判断
// （指摘が入って書き換わったたらこのコメント丸ごと消してください）
// globals.scssでこのlangに従ってフォントを書き換えるコードなどを仕込んでいるのでここを書き換える時は注意
// @see https://qiita.com/flatsato/items/c7c1e2d26218523d27b2
//      https://developers.google.com/search/docs/specialty/international/localized-versions
export const getHtmlLang = (lang: string) => {
  switch (lang) {
    case "en":
      return "en";
    case "zh-cn":
      return "zh-Hans";
    case "zh-tw":
      return "zh-Hant";
    case "ko":
      return "ko";
    default:
      console.error(`[getHtmlLang] 不正な引数: ${lang}`)
      return "";
  }
}